import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Pagination from '../../react-components/pagination';
import { constEvent } from '../../utils/constants';
import { isPhoneOnly } from '../../utils/breakpoints';

const MAX_RESULTS_COVEO_CAN_PARSE = 1000;

const Index = props => {
  const [page, setPage] = useState();
  const [totalPages, setTotalPages] = useState();
  const [itemsPerPageOptions, setItemsPerPageOptions] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState();

  console.log(itemsPerPageOptions);

  const getTotalPages = params => {
    console.log('page params', params);
    if (params.totalResults <= MAX_RESULTS_COVEO_CAN_PARSE) return params.totalPages;
    return Math.ceil(MAX_RESULTS_COVEO_CAN_PARSE / params.resultsPerPage);
  }

  const onPageChange = newPage => {
    const CoveoPager = document.querySelector('.CoveoPager').CoveoPager;
    CoveoPager.setPage(newPage);
  }

  const onItemsPerPageChange = newValue => {
    const CoveoResultsPerPage = document.querySelector('.CoveoResultsPerPage').CoveoResultsPerPage;
    CoveoResultsPerPage.setResultsPerPage(parseInt(newValue, 10))
  }

  const parseCoveoResults = e => {
    const CoveoPager = document.querySelector('.CoveoPager')?.CoveoPager || { currentPage: 1 };
    const CoveoResultsPerPage = document.querySelector('.CoveoResultsPerPage')?.CoveoResultsPerPage || { resultsPerPage: 8, options: { choicesDisplayed: [8, 12, 24] } };
    const totalResults = e?.results?.totalCount;
    const totalPages = Math.ceil(parseInt(totalResults, 10) / CoveoResultsPerPage.resultsPerPage)
    console.log('build', totalResults, totalPages);
    return {
      currentPage: CoveoPager.currentPage,
      setPage: CoveoPager.setPage,
      totalResults,
      totalPages,
      resultsPerPage: CoveoResultsPerPage.resultsPerPage,
      resultsPerPageOptions: CoveoResultsPerPage.options.choicesDisplayed,
      setResultsPerPage: CoveoResultsPerPage.setResultsPerPage
    }
  }

  const setNewData = e => {
    const detail = parseCoveoResults(e.detail);
    console.log('built', detail);
    const resultsPerPage = isPhoneOnly() ? 12 : detail?.resultsPerPage;
    setPage(detail?.currentPage);
    setTotalPages(getTotalPages({
      totalPages: detail?.totalPages,
      totalResults: detail?.totalResults,
      resultsPerPage
    }));
    setItemsPerPage(resultsPerPage);
    setItemsPerPageOptions(detail?.resultsPerPageOptions);
  }

  const onCoveoResultsUpdated = () => {
    if (isPhoneOnly()) setItemsPerPage(12);
    document._on(constEvent.COVEO_RESULTS_UPDATED, setNewData);
  }

  useEffect(onCoveoResultsUpdated, [onCoveoResultsUpdated]);

  return page && totalPages > 1 ? (
    <div>
      <Pagination
        labelItemsPerPage={props.labelItemsPerPage}
        labelPrev={props.labelPrev}
        labelNext={props.labelNext}
        onPageChange={onPageChange}
        onItemsPerPageChange={onItemsPerPageChange}
        current={page}
        total={totalPages}
        itemsPerPage={`${itemsPerPage}`}
        itemsPerPageOptions={itemsPerPageOptions.join(',')}
        externalPerPageContainerId="product-category-listing-header-sort"
      />
    </div>
  ) : null;
}

Index.propTypes = {
  labelItemsPerPage: PropTypes.string,
  labelPrev: PropTypes.string,
  labelNext: PropTypes.string
}

export default Index;
